export default {
	dashboard: {
		documents: {
			title: 'Neue Dokumente',
			updatedSinceLastLogin:
				'Diese Dokumente wurden seit Ihrer letzten {lastLogin} aktualisiert.',
		},
		buildings: {
			myObjects: 'Meine Objekte',
		},
	},
}
